import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import styles from '../../../styles/Home.module.css'

const Card = () => {
  return (
    <Container style={{ margin: '5em auto' }}>
      <h1 className={styles.SectionHeading}>Everyone&apos;s Favorite All-In-One Social HR Software</h1>
      <div className={styles.decoraion} style={{ width: '100px', margin: '1.25em 0 0em 0' }}></div>
      <p className={styles.SectionSubHeading}>From the point you start looking for a candidates, to the point where you hire them, and then from on-boarding to the entire lifecycle of an employee - all the way to the point where an employee exists - we&apos;ve got it all covered.</p>
      <Row>
        <Col className={styles.landingCard}>
          <h1>28,000 +</h1>
          <p>Companies Onboard</p>
        </Col>
        <Col className={styles.landingCard}>
          <h1>1,000,000 +</h1>
          <p>Employees Served</p>
        </Col>
        <Col className={styles.landingCard}>
          <h1>200</h1>
          <p>Countries Globally</p>
        </Col>
      </Row>
    </Container>
  )
}

export default Card
